$(function() {

/*
	//ENABLE POPOVERS
	$('[data-toggle="popover"]').popover({
		trigger: 'focus',
		html:true
	});

	// ENABLE TOOLTIPS
 	$('[data-toggle="tooltip"]').tooltip();
*/
 	// SEARCH FIELD

 	$(".header-search").mouseenter( function(){
 		$(this).addClass('active');
 		}).mouseleave(function(){
 			var sField = $(this).find('.form-control');
 				fieldWrapper = $(this);
		 		if ($(sField).val().length === 0){
		 			$(fieldWrapper).removeClass('active');
		 		}
 			}
 		)
	
	
	// IMAGE TO BACKGROUND
	$(".background, .bg-responsive-md").each(function(){
	 	var bgItem = $(this).find("> .bg-image:not(.sr-md-only)");
	 		itemSource = $(bgItem).attr('src');
	 		$(this).css({'background-image' : 'url('+itemSource+')'});
	});

	function bgStretch(){
		var bgItem = $(this).find("> .bg-image");
			itemSource = $(bgItem).attr('src');
			itemHeight = bgItem.naturalHeight;
			$(this).css({'background-image' : 'url('+itemSource+')', 'height' : itemHeight});
			// $(".background-stretch").innerHeight(itemHeight);
			alert(bgItem.naturalHeight)
	}

	$(".interactive").each(function(){
		$(this).children(".interactive-items .interactive-item").on('click', function(){
			var itemIndex = $(this).prop('data-link');
			alert(itemIndex);
		})
	});
	// $(".background-stretch").each(function(){
	//  	var bgItem = $(this).find("> .bg-image");
	//  		itemSource = $(bgItem).attr('src');
	//  		// itemHeight = $(bgItem).prop(image.naturalHeight);
	//  		// $(this).css({'background-image' : 'url('+itemSource+')', 'height' : bgItem.naturalHeight});
	//  		alert($(bgItem).prop(img.naturalHeight));
	// });
	$(".interactive-item").on('hover', function(){
		// var interactiveID = $(this).prop('data-link');
		$(this).hide();
	});


});


$(window).on('load', function(){
	$(".background-stretch").each(function(){
	 	var bgItem = $(this).find("> .bg-image");
	 		itemSource = $(bgItem).attr('src');
	 		itemHeight = $(bgItem).prop('naturalHeight');
	 		$(this).css({'background-image' : 'url('+itemSource+')', 'height' : itemHeight});
	});
})
	// HEADER FULL-HEIGHT

	// function heroFull(){
	// 	var wHeight = $(window).height();
	// 		headerHeight = parseInt($('body').css('padding-top'));
	// 	$('.hero').innerHeight(wHeight - headerHeight);
	// }

	// $(window).on('load resize', function(){
	// 	heroFull();
	// });
